import _defineProperty from "/home/runner/work/neartrees/neartrees/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var SIDE_OPTIONS = ["top", "right", "bottom", "left"];
export var ALIGN_OPTIONS = ["start", "center", "end"];
export function getPlacementData(_ref) {
  var p = _ref.anchorRect,
      c = _ref.popperSize,
      f = _ref.arrowSize,
      _ref$arrowOffset = _ref.arrowOffset,
      l = _ref$arrowOffset === void 0 ? 0 : _ref$arrowOffset,
      d = _ref.side,
      _ref$sideOffset = _ref.sideOffset,
      h = _ref$sideOffset === void 0 ? 0 : _ref$sideOffset,
      x = _ref.align,
      _ref$alignOffset = _ref.alignOffset,
      g = _ref$alignOffset === void 0 ? 0 : _ref$alignOffset,
      _ref$shouldAvoidColli = _ref.shouldAvoidCollisions,
      u = _ref$shouldAvoidColli === void 0 ? !0 : _ref$shouldAvoidColli,
      w = _ref.collisionBoundariesRect,
      _ref$collisionToleran = _ref.collisionTolerance,
      m = _ref$collisionToleran === void 0 ? 0 : _ref$collisionToleran;
  if (!p || !c || !w) return {
    popperStyles: o,
    arrowStyles: n
  };

  var y = function (e, r) {
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var i = arguments.length > 4 ? arguments[4] : undefined;
    var p = i ? i.height : 0,
        a = t(r, e, "x"),
        s = t(r, e, "y"),
        c = s.before - o - p,
        f = s.after + o + p,
        l = a.before - o - p,
        d = a.after + o + p;
    return {
      top: {
        start: {
          x: a.start + n,
          y: c
        },
        center: {
          x: a.center,
          y: c
        },
        end: {
          x: a.end - n,
          y: c
        }
      },
      right: {
        start: {
          x: d,
          y: s.start + n
        },
        center: {
          x: d,
          y: s.center
        },
        end: {
          x: d,
          y: s.end - n
        }
      },
      bottom: {
        start: {
          x: a.start + n,
          y: f
        },
        center: {
          x: a.center,
          y: f
        },
        end: {
          x: a.end - n,
          y: f
        }
      },
      left: {
        start: {
          x: l,
          y: s.start + n
        },
        center: {
          x: l,
          y: s.center
        },
        end: {
          x: l,
          y: s.end - n
        }
      }
    };
  }(c, p, h, g, f),
      b = y[d][x];

  if (!1 === u) {
    var _t = e(b);

    var _o = n;
    f && (_o = i({
      popperSize: c,
      arrowSize: f,
      arrowOffset: l,
      side: d,
      align: x
    }));
    return {
      popperStyles: _objectSpread(_objectSpread({}, _t), {}, {
        "--radix-popper-transform-origin": r(c, d, x, l, f)
      }),
      arrowStyles: _o,
      placedSide: d,
      placedAlign: x
    };
  }

  var S = DOMRect.fromRect(_objectSpread(_objectSpread({}, c), b)),
      $ = (O = w, z = m, DOMRect.fromRect({
    width: O.width - 2 * z,
    height: O.height - 2 * z,
    x: O.left + z,
    y: O.top + z
  }));
  var O, z;

  var R = s(S, $),
      M = y[a(d)][x],
      D = function (t, e, r) {
    var o = a(t);
    return e[t] && !r[o] ? o : t;
  }(d, R, s(DOMRect.fromRect(_objectSpread(_objectSpread({}, c), M)), $)),
      A = function (t, e, r, o, n) {
    var i = "top" === r || "bottom" === r,
        p = i ? "left" : "top",
        a = i ? "right" : "bottom",
        s = i ? "width" : "height",
        c = e[s] > t[s];
    if (("start" === o || "center" === o) && (n[p] && c || n[a] && !c)) return "end";
    if (("end" === o || "center" === o) && (n[a] && c || n[p] && !c)) return "start";
    return o;
  }(c, p, d, x, R),
      I = e(y[D][A]);

  var C = n;
  f && (C = i({
    popperSize: c,
    arrowSize: f,
    arrowOffset: l,
    side: D,
    align: A
  }));
  return {
    popperStyles: _objectSpread(_objectSpread({}, I), {}, {
      "--radix-popper-transform-origin": r(c, D, A, l, f)
    }),
    arrowStyles: C,
    placedSide: D,
    placedAlign: A
  };
}

function t(t, e, r) {
  var o = t["x" === r ? "left" : "top"],
      n = "x" === r ? "width" : "height",
      i = t[n],
      p = e[n];
  return {
    before: o - p,
    start: o,
    center: o + (i - p) / 2,
    end: o + i - p,
    after: o + i
  };
}

function e(t) {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "max-content",
    willChange: "transform",
    transform: "translate3d(".concat(Math.round(t.x + window.scrollX), "px, ").concat(Math.round(t.y + window.scrollY), "px, 0)")
  };
}

function r(t, e, r, o, n) {
  var i = "top" === e || "bottom" === e,
      p = n ? n.width : 0,
      a = n ? n.height : 0,
      s = p / 2 + o;
  var c = "",
      f = "";
  return i ? (c = {
    start: "".concat(s, "px"),
    center: "center",
    end: t.width - s + "px"
  }[r], f = "top" === e ? "".concat(t.height + a, "px") : -a + "px") : (c = "left" === e ? "".concat(t.width + a, "px") : -a + "px", f = {
    start: "".concat(s, "px"),
    center: "center",
    end: t.height - s + "px"
  }[r]), "".concat(c, " ").concat(f);
}

var o = {
  position: "fixed",
  top: 0,
  left: 0,
  opacity: 0,
  transform: "translate3d(0, -200%, 0)"
},
    n = {
  position: "absolute",
  opacity: 0
};

function i(_ref2) {
  var _f;

  var t = _ref2.popperSize,
      e = _ref2.arrowSize,
      r = _ref2.arrowOffset,
      o = _ref2.side,
      n = _ref2.align;
  var i = (t.width - e.width) / 2,
      a = (t.height - e.width) / 2,
      s = {
    top: 0,
    right: 90,
    bottom: 180,
    left: -90
  }[o],
      c = Math.max(e.width, e.height),
      f = (_f = {
    width: "".concat(c, "px"),
    height: "".concat(c, "px"),
    transform: "rotate(".concat(s, "deg)"),
    willChange: "transform",
    position: "absolute"
  }, _defineProperty(_f, o, "100%"), _defineProperty(_f, "direction", p(o, n)), _f);
  return "top" !== o && "bottom" !== o || ("start" === n && (f.left = "".concat(r, "px")), "center" === n && (f.left = "".concat(i, "px")), "end" === n && (f.right = "".concat(r, "px"))), "left" !== o && "right" !== o || ("start" === n && (f.top = "".concat(r, "px")), "center" === n && (f.top = "".concat(a, "px")), "end" === n && (f.bottom = "".concat(r, "px"))), f;
}

function p(t, e) {
  return ("top" !== t && "right" !== t || "end" !== e) && ("bottom" !== t && "left" !== t || "end" === e) ? "ltr" : "rtl";
}

function a(t) {
  return {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[t];
}

function s(t, e) {
  return {
    top: t.top < e.top,
    right: t.right > e.right,
    bottom: t.bottom > e.bottom,
    left: t.left < e.left
  };
}